import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GeolocationService {
	constructor() {}

	public getPosition(): Observable<GeolocationPosition> {
		return new Observable((observer: Observer<GeolocationPosition>) => {
			// Check if the browser supports the Geolocation API
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position: GeolocationPosition) => {
						observer.next(position);
						observer.complete();
					},
					(error: GeolocationPositionError) => {
						observer.error(error);
					}
					// Optional options
					// { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
				);
			} else {
				observer.error('Geolocation not supported by this browser.');
			}
		});
	}

	calculateDistance(lat1, lon1, lat2, lon2) {
		const R = 6371; // Earth's radius in km
		const dLat = ((lat2 - lat1) * Math.PI) / 180; // Convert degrees to radians
		const dLon = ((lon2 - lon1) * Math.PI) / 180;
		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c * 1000; // Distance in meters
	}
}
